import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';
import { useAuthenticationContext, AuthenticationErrors } from '../../../yoello-lib/modules/auth/AuthenticationContext';
import { HOME_URL, VENUES } from '../../../const/URL.const';
import { useHistory } from 'react-router-dom';
import { useUserLogout } from '../../../hooks/useUserLogout';



export interface ILoginFormData {
  username: string;
  password: string;
}

export function useLoginView() {
  const { userLogin, verifyAuth, checkIfNewPasswordRequired } = useAuthenticationContext();
  const { logout } = useUserLogout();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState<ILoginFormData|undefined>(undefined);
  const { t } = useTranslation();
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const history = useHistory();

  useEffect(() => {
    async function checkUserVerification() {
      try {
        const user = await verifyAuth();
        if (!user) {
          history.push(HOME_URL + history.location.search);
          logout();
        } else {
          history.push(VENUES + history.location.search);
        }
      } catch (error: any) {
        logout();
      }
    }
    checkUserVerification();
    // eslint-disable-next-line
  }, []);

  async function onSubmit(data: any) {
    const submittedData = {
      ...data,
      username : data.username.trimEnd().toLowerCase()
    } as ILoginFormData;
    setIsLoading(true);
    try {
      const isNewPasswordRequired = await checkIfNewPasswordRequired(submittedData.username, submittedData.password);
      if (isNewPasswordRequired) {
        setState({
          username : submittedData.username,
          password : submittedData.password
        });
      } else {
        const result = await userLogin(submittedData.username, submittedData.password);
        history.push(VENUES + history.location.search);
        if (result === AuthenticationErrors.NotAuthorizedException) {
          sendSnackbarMessage(
            t("forms.login.Errors.IncorrectEmailOrPassword").toString(),
            "error"
          );
          setIsLoading(false);
          logout();
        } else if (result === AuthenticationErrors.UserNotFoundException) {
          sendSnackbarMessage(
            t("forms.login.Errors.notFound").toString(),
            "error"
          );
          setIsLoading(false);
          logout();
        }
      }

    } catch (error:any) {
      if(error.message.includes(AuthenticationErrors.NotAuthorizedException)){
        sendSnackbarMessage(
          t("forms.login.Errors.IncorrectEmailOrPassword").toString(),
          "error"
        );
      }else if(error.message.includes(AuthenticationErrors.UserNotFoundException)){
        sendSnackbarMessage(
          t("forms.login.Errors.notFound").toString(),
          "error"
        );
      }else if(error.message.includes(AuthenticationErrors.UserNotConfirmedException)){
        sendSnackbarMessage(
          t("forms.login.Errors.UserNotConfirmedException").toString(),
          "error"
        );
      }else{
        sendSnackbarMessage(
          t("forms.login.Errors.LoginIssue").toString(),
          "error"
        );
      }
      setIsLoading(false);
      logout();
    }
  }
  return {
    onSubmit,
    isLoading,
    state
  }
}
